import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby-link";
import BgImg from "../../../images/locationgcc/game/journey.webp";

function Laverage(props) {
  return (
    <div
      className="laverage_section p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundColor: "#F8F8FB",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2>
              The Mobile <span>Game App Development</span> Journey We Follow
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              Boarding on the conception of exceptional mobile game apps is a
              planned journey at our development agency. Dedicated to providing
              leading-edge solutions for Dubai and the GCC region, we follow a
              methodically created and time-proven procedure, driving us to
              become one of the leading mobile game development companies in
              Dubai, UAE.
            </p>
            <p style={{ color: "#000" }}>
              Here is the process that is followed for custom software
              development
            </p>
          </Col>

          <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
            <div className="process_listing">
              <div className="process_item">
                <div className="number">01</div>
                <h6>Conceptualization and Planning</h6>
                <p>
                  Collaboratively improve your game ideas, framework mechanics,
                  features, and layout, and develop a comprehensive project plan
                  with milestones and timelines.
                </p>
              </div>
              <div className="process_item">
                <div className="number">02</div>
                <h6>Design Prototyping</h6>
                <p>
                  Create interactive prototypes to display the game's interface,
                  user experience, and aesthetics, enabling feedback and
                  iterative refinement for future updates and improvements.
                </p>
              </div>
              <div className="process_item">
                <div className="number">03</div>
                <h6>Development Kickoff</h6>
                <p>
                  Start the process of coding, guaranteeing adherence to
                  standards, optimization, and compatibility across different
                  devices and platforms.
                </p>
              </div>
              <div className="process_item">
                <div className="number">04</div>
                <h6>Quality Assurance</h6>
                <p>
                  Conduct strict testing to classify and remedy bugs or
                  performance problems, authenticating functionality, usability,
                  and complete stability.
                </p>
              </div>
              <div className="process_item">
                <div className="number">05</div>
                <h6>Client Review and Approval</h6>
                <p>
                  {" "}
                  Deliver the completed mobile game for detailed review,
                  incorporate response, and make modifications to align with
                  client expectations.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Laverage;
